import React from "react";
import { notification } from "antd";
import { userKcService } from "./../services/UserKcService";
import { UserDoctorDto } from "./../models/UserDoctorDto";
import { useLoaderProvider } from "../contexts/LoaderContext";
import UserProfileForm from "../components/user-profile/UserProfileForm";
import { routes } from "../routes";
import { useNavigate } from "react-router-dom";
import { AuthorityDTO } from "../models/Authority";
import { AUTHORITIES } from "../config/constants";

const RegistrationPage: React.FC = () => {
  const { showLoader, hideLoader } = useLoaderProvider();
  const navigate = useNavigate();

  const onFinish = async (values: UserDoctorDto) => {
    showLoader("Registrazione in corso...");
    try {
      // hardcoded role per la registrazione
      values.authorities = [
        { name: AUTHORITIES.ASL_DOCTOR } as unknown as AuthorityDTO,
      ];
      await userKcService.createUser(values);
      notification.success({
        message: "Registrazione avvenuta con successo",
        description: "Riceverai una mail quando il tuo account sarà attivato.",
      });

      navigate(routes.HOME);
    } catch (error) {
      notification.error({
        message: "Errore durante la registrazione",
      });
    } finally {
      hideLoader();
    }
  };

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "24px" }}>
      <UserProfileForm onFinish={onFinish} />
    </div>
  );
};

export default RegistrationPage;
